import { FC } from 'react'
import { Box, CircularProgress } from '@mui/material'

type LoadedSpinnerProps = {
  size?: number
  inline?: boolean
}

const LoadedSpinner: FC<LoadedSpinnerProps> = ({ size, inline }) => {
  // If neither size nor inline is provided, use original full-width layout
  if (size === undefined && !inline) {
    return (
      <Box
        sx={{
          width: '25%',
          marginLeft: 'auto',
          marginRight: 'auto',
          marginTop: 4,
        }}
      >
        <CircularProgress />
      </Box>
    )
  }

  // Inline or sized spinner
  return (
    <Box
      sx={{
        display: inline ? 'inline-flex' : 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: inline ? 'auto' : '25%',
        m: inline ? 0 : 'auto',
      }}
    >
      <CircularProgress size={size} />
    </Box>
  )
}

export default LoadedSpinner
